var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 21",
    style: {
      enableBackground: "new 0 0 22 21"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20,20.9L14.2,19c-1,0.3-2.1,0.4-3.2,0.4c-5.8,0-10.5-4.3-10.5-9.5S5.2,0.3,11,0.3c5.8,0,10.5,4.3,10.5,9.5 c0,2.5-1.1,4.9-3,6.7L20,20.9z M14.2,16.9l2.6,0.9l-0.6-1.8l0.5-0.4c1.8-1.4,2.8-3.5,2.8-5.6c0-4.2-3.8-7.5-8.5-7.5 S2.5,5.7,2.5,9.9s3.8,7.5,8.5,7.5c1,0,2-0.1,2.9-0.4L14.2,16.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComment);
export default __webpack_public_path__ + "static/media/icon-comment.07a3482a74ac3a2ed0399ea31e0beb33.svg";
export { ForwardRef as ReactComponent };